<div class="card-skeleton">
  <div class="card-skeleton-header">
    <inexp-skeleton width="60%" height="1.25rem" />
    <inexp-skeleton width="2rem" height="2rem" radius="50%" />
  </div>
  <div class="card-skeleton-body">
    <inexp-skeleton width="100%" height="0.875rem" />
    <inexp-skeleton width="90%" height="0.875rem" />
    <inexp-skeleton width="75%" height="0.875rem" />
  </div>
  <div class="card-skeleton-footer">
    <inexp-skeleton width="5rem" height="1.5rem" radius="12px" />
    <inexp-skeleton width="5rem" height="1.5rem" radius="12px" />
  </div>
</div>
